module.exports = __webpack_public_path__ + "img/icono-wp.3426b2ca.png";